import { Link } from "gatsby"
import React from "react"
import { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Styles from "./Nav.module.scss"
import NavWidget from "./NavWidget"
import StaliaLogo from "../../images/stalia-icon.png"

const Navigation = () => {
  const navigationMobileSize = 599

  if (typeof window === "undefined") {
    global.window = {}
  }

  const [navigationOpen, determineNavState] = useState(false)

  const isMobileSize = () => {
    window.innerWidth < navigationMobileSize
      ? determineNavState(false)
      : determineNavState(true)
  }

  useEffect(() => {
    // start with the Nav Closed. once the page has loaded then load nav once.
    determineNavState(window.innerWidth > navigationMobileSize ? true : false)
  }, []) // array causes only runs once on render

  useEffect(() => {
    window.addEventListener("resize", isMobileSize)
    return () => {
      window.removeEventListener("resize", isMobileSize)
    }
  }, [isMobileSize])

  const data = useStaticQuery(graphql`
    {
      allContentfulGeneral {
        edges {
          node {
            id
            siteTitle
            siteSubtitle
            instagramLink
            companyLogo {
              fluid {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
      allContentfulNavigationMenu {
        edges {
          node {
            navigationLinks {
              name
            }
          }
        }
      }
    }
  `)

  // destructuring object for readability
  const {
    siteTitle,
    siteSubtitle,
    // companyLogo,
  } = data.allContentfulGeneral.edges[0].node
  const navCategories =
    data.allContentfulNavigationMenu.edges[0].node.navigationLinks

  return (
    <div className={Styles.nav}>
      <div className={Styles.navheader}>
        {window.innerWidth < navigationMobileSize ? (
          <button
            className={Styles.hamburger}
            onClick={() => {
              !navigationOpen
                ? determineNavState(true)
                : determineNavState(false)
            }}
          >
            <div></div>
            <div></div>
            <div></div>
          </button>
        ) : null}
        {/* the container has been named header as there is a bug in gatsby that strips out styles if it is div */}
        <header className={Styles.titlecontainer}>
          <Link to="/">
            <h1 className={Styles.title}>{siteTitle}</h1>
            <p className={Styles.subtitle}>{siteSubtitle}</p>
          </Link>
        </header>

        <NavWidget />
      </div>

      {navigationOpen ? (
        <div className={Styles.navmenu}>
          <ul>
            <div
              onClick={() => {
                if (window.innerWidth < navigationMobileSize) {
                  determineNavState(false)
                }
              }}
              className={Styles.navMenuLogo}
              key={"logoNavmenu"}
            >
              <Link to={`/`} activeStyle={{ color: "#fc7ca0" }}>
                Stalia London
              </Link>
            </div>
            {/* <img className={Styles.logo} src={StaliaLogo} alt="brand logo" /> */}
            {navCategories.map(category => {
              const { name } = category
              // use category name to create a slug
              const link = name.toLowerCase()

              return (
                <li
                  onClick={() => {
                    if (window.innerWidth < navigationMobileSize) {
                      determineNavState(false)
                    }
                  }}
                  className={Styles.navlink}
                  key={name}
                >
                  <Link to={`/${link}`} activeStyle={{ color: "#fc7ca0" }}>
                    {name}
                  </Link>
                </li>
              )
            })}
          </ul>
          <div
            onClick={() => {
              determineNavState(false)
            }}
            className={Styles.opaqueblock}
          />
          <div
            onClick={() => {
              determineNavState(false)
            }}
            className={Styles.closebtn}
          >
            <div></div>
            <div></div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default Navigation
